import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EntityTableRow, { EntityTableRowProps } from 'components/EntityTableRow';

import { TravelDocumentsListRow_document$key } from '__generated__/TravelDocumentsListRow_document.graphql';
import TableCell from 'components/TableCell';
import Link from '@mui/material/Link';

type Props = EntityTableRowProps & {
  document: TravelDocumentsListRow_document$key;
};

const TravelDocumentsListRow = ({ document, ...props }: Props) => {
  const documentData = useFragment(
    graphql`
      fragment TravelDocumentsListRow_document on TravelDocument {
        id
        name

        ...EntityTableRow_entity
      }
    `,
    document
  );

  const { id, name } = documentData;

  return (
    <EntityTableRow entity={documentData} {...props}>
      <TableCell>
        <Link href={id}>{name}</Link>
      </TableCell>
    </EntityTableRow>
  );
};

export default TravelDocumentsListRow;
